import tw from "twin.macro";

import { BaseButton } from "../../shared/components/BaseButton";

export const Button = tw(BaseButton)`
  text-xl
  font-semibold
  leading-[0]
`;
